<template>
	<b-modal
		:hide-footer="true"
		:hide-header-close="true"
		:no-close-on-backdrop="true"
		:no-close-on-esc="true"
		:title="$t('Editar Tipo de Unidade')"
		centered
		id="add-tipo-unidade"
		no-fade
	>
		<template v-slot:default>
			<loading-animation
				:active.sync="loading"
				:is-full-page="false"
				:opacity="1"
				color="#5895FF"
			/>
			<form @submit.prevent="editTipoUnidade" ref="editTipoUnidade">
				<b-form-group class="mb-2" label-for="nome">
					<template v-slot:label
						>{{ $t("Nome") }} <span class="text-danger">*</span></template
					>
					<b-form-input id="nome" required v-model="item.nome" />
				</b-form-group>

				<div class="float-right mt-3">
					<router-link class="btn btn-danger" to="/dashboard/tiposunidade">
						<i class="mdi mdi-close" />
						{{ $t("Cancelar") }}
					</router-link>
					<button class="btn btn-success btn-submit" data-style="zoom-in" type="submit">
						<i class="mdi mdi-content-save" />
						{{ $t("Salvar") }}
					</button>
				</div>
			</form>
		</template>
	</b-modal>
</template>

<script>
export default {
	name: "Add",
	mounted() {
		this.$bvModal.show("add-tipo-unidade");
		this.getTipoUnidade();
	},
	data() {
		return {
			loading: true,
			item: {
				nome: null,
			},
		};
	},
	methods: {
		getTipoUnidade() {
			this.loading = true;
			axios
				.get("api/dashboard/tipounidade/" + this.$route.params.id)
				.then((response) => {
					this.item = response.data.data;
					this.loading = false;
				})
				.catch(() => {
					this.$router.push("/dashboard/tiposunidade");
				});
		},
		editTipoUnidade() {
			let ladda = Ladda.create(document.querySelector(".btn-submit"));
			ladda.start();
			// Send request
			axios
				.put("api/dashboard/tipounidade/" + this.item.id, this.item)
				.then((response) => {
					ladda.stop();
					this.$snack.success({
						button: false,
						text: response.data.data.message,
					});
					this.$router.push("/dashboard/tiposunidade");
					this.$parent.getTipoUnidades();
				});
		},
	},
};
</script>
